module.exports = __webpack_public_path__ + "img/thaw-drivers.0537a7fd.jpg";